
























import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import Company from "../../models/company/Company";
import {Icon} from "@/helpers/icons";
import {
	createAddressLinesArray,
	createAddressPersonLine,
	createEmailArray,
	createPhoneString
} from "@/helpers/functions_td";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import CompanyUpdateDialogBillingAddress from "@/components/company/CompanyUpdateDialogBillingAddress.vue";
import AddressBilling from "@/models/address/AddressBilling";
import AsiAlert from "@/components/common/AsiAlert.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {AsiAlert, CompanyUpdateDialogBillingAddress, AsiCardDetailEntry, AsiCardDetail}
})
export default class CompanyCardBillingAddress extends Vue {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get personLines(): string[] | null {
		return createAddressPersonLine(this.company?.billingAddress ?? null);
	}

	private get addressLines(): string[] | null {
		return createAddressLinesArray(this.company?.billingAddress ?? null);
	}

	private get emailEntries(): string[] | null {
		return createEmailArray(this.company?.billingAddress.emails ?? null);
	}

	private get phoneString(): string | null {
		return createPhoneString(this.company?.billingAddress.phone ?? null);
	}

	private get hasEnoughInformationForBilling(): boolean {
		if (this.company === null) return false;
		return AddressBilling.hasEnoughInformationForBilling(this.company.billingAddress);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	@Emit('companyChanged')
	public companyChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
